import permissionsReducer from "./reducers";
export { default as permissionsTypes } from "./types";
export { default as permissionsOperations } from "./operations";
export default permissionsReducer;
